@if (!control.disabled) {
  <div class="search-container pt-3">
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>{{ searchPlaceholder() }}</mat-label>
      <input matInput [formControl]="searchControl" autocomplete="off" />
      <ng-container matSuffix>
        @if (searchTermSignal()) {
          <button
            mat-icon-button
            matSuffix
            (click)="searchControl.setValue('')"
            aria-label="Clear search"
            >
            <mat-icon>close</mat-icon>
          </button>
        }
      </ng-container>
    </mat-form-field>
  </div>
}
<div class="list-container" [style.max-height]="maxHeight()">
  <mat-selection-list
    role="list"
    [formControl]="control"
    (selectionChange)="onTouched()"
    >
    @for (item of items(); track item.id) {
      <mat-list-option
        role="listitem"
        [value]="item.id"
        [matTooltip]="item[itemTooltipKey()]"
        matTooltipPosition="above"
        [ngClass]="{ 'hidden!': !visibleItems().includes(item) }"
        >
        {{ item[itemLabelKey()] }}
      </mat-list-option>
    }
  </mat-selection-list>

  @if (visibleItems().length === 0 && searchTermSignal()) {
    <div class="no-results">Nessun risultato</div>
  }
</div>
